import React from 'react';
import EndPier1Board from './EndPier1Board';

const EndPier1 = () => <EndPier1Board />;

export default EndPier1;
